import styled from "styled-components";

export const Container = styled.div`
  position: fixed;
  z-index: 99999999999;
  background-color: RGBA(0, 0, 0, 0.8);
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-items: center;

  input {
    width: 100%;
  }

  .field {
    align-items: start !important;
  }

  .close {
    animation: fadeoutprivacy 0.4s;

    @keyframes fadeinprivacy {
      from {
        transform: scale(1);
        opacity: 1;
      }

      to {
        transform: scale(0);
        opacity: 0.95;
      }
    }

    opacity: 0;
    display: none;
  }

  .on {
    animation: fadeinprivacy 0.6s;
    opacity: 1;

    @keyframes fadeinprivacy {
      from {
        transform: scale(0);
        opacity: 0;
      }

      to {
        transform: scale(1);
        opacity: 0.95;
      }
    }
  }

  .content {
    border-radius: 6px;
    padding: 1.5rem;
    margin: auto;
    background-color: #fff;
    color: #333;
    overflow: auto;
    display: flex;
    flex-direction: column;

    @media (max-width: 900px) {
      padding-bottom: 5rem;
    }

    p {
      font-size: 1.4rem;
      font-weight: 500;
      margin-bottom: 0.6rem;
    }

    section {
      display: block;

      margin-bottom: 1.3rem;

      p {
        font-weight: 400;
        font-size: 0.875rem;
        margin-bottom: 0.6rem;
      }

      ol {
        margin-left: 1.8rem;
      }
    }

    div {
      width: 100%;

      .button-close {
        cursor: pointer;
        flex: 1;
        display: block;
        padding: 0.875rem;
        text-align: center;
        gap: 4px;
        background-color: transparent;
        color: #000;
        font-weight: 400;
        text-decoration: underline !important;
      }
    }
  }
`;
